// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","513":"936a576d","632":"6d90044b","657":"0eb819f4","706":"711ede07","726":"759a3e6d"}[chunkId] + ".chunk.js";
};